import { rpcDefinition } from "@redotech/redo-merchant-marketing-rpc/definition";
import type { ClientOptions } from "@redotech/rpc/client";
import { createRpcContractClient } from "@redotech/rpc/client";
import type { RedoMarketingRpcContract } from "./rpc-contract.generated";

export function createRedoMarketingRpcClient(
  options: ClientOptions<RedoMarketingRpcContract>,
): RedoMarketingRpcContract {
  return createRpcContractClient<RedoMarketingRpcContract>(
    rpcDefinition,
    options,
  );
}

export type RedoMarketingRpcClient = RedoMarketingRpcContract;
